import { queryKeys } from '@/shared/hooks';

export const executionKeys = {
  suiteExecutions: (projectId?: string | null, orgId?: string | null) =>
    queryKeys.suiteExecutions(projectId, orgId),
  suiteExecutionDetail: (id: string | null, orgId?: string | null) =>
    queryKeys.suiteExecutionDetail(id, orgId),
  suiteExecutionRunNumber: (id: string | null, orgId?: string | null) =>
    [...queryKeys.suiteExecutionDetail(id, orgId), 'run-number'] as const,
  suiteExecutionRunDetail: (
    suiteSlug: string | null,
    runNumber: number | null,
    projectId?: string | null,
    orgId?: string | null,
  ) =>
    [
      'suiteExecutions',
      'detail-run',
      orgId ?? 'personal',
      projectId ?? 'unknown-project',
      suiteSlug ?? 'unknown',
      runNumber ?? 'unknown',
    ] as const,
  testExecutions: (projectId?: string | null, orgId?: string | null) =>
    queryKeys.testExecutions(projectId, orgId),
  testExecutionDetail: (id: string | null, orgId?: string | null) =>
    queryKeys.testExecutionDetail(id, orgId),
  testExecutionRunDetail: (
    testSlug: string | null,
    runNumber: number | null,
    projectId?: string | null,
    orgId?: string | null,
  ) =>
    [
      'testExecutions',
      'detail-run',
      orgId ?? 'personal',
      projectId ?? 'unknown-project',
      testSlug ?? 'unknown',
      runNumber ?? 'unknown',
    ] as const,
};
